'use client'

import React, { useEffect } from 'react'
import { atom, useSetRecoilState } from 'recoil'

export const lineMiniAppLiffIdState = atom({
  key: 'lineMiniAppLiffId',
  default: '',
})

export const lineLoginLiffIdState = atom({
  key: 'lineLoginLiffId',
  default: '',
})

export default function LiffIdProvider({
  children,
  lineMiniAppLiffId,
  lineLoginLiffId,
}: {
  children: React.ReactNode
  lineMiniAppLiffId: string
  lineLoginLiffId: string
}) {
  return (
    <>
      <SetLiffId lineMiniAppLiffId={lineMiniAppLiffId} lineLoginLiffId={lineLoginLiffId} />
      {children}
    </>
  )
}

const SetLiffId = ({ lineMiniAppLiffId, lineLoginLiffId }: { lineMiniAppLiffId: string; lineLoginLiffId: string }) => {
  const setLineMiniAppLiffId = useSetRecoilState(lineMiniAppLiffIdState)
  const setLineLoginLiffId = useSetRecoilState(lineLoginLiffIdState)

  useEffect(() => {
    setLineMiniAppLiffId(lineMiniAppLiffId)
    setLineLoginLiffId(lineLoginLiffId)
  }, [])

  return <></>
}
